export const fetchPartitionsAndSessions = async (selectedDate) => {
  try {
    const programItems = JSON.parse(localStorage.getItem('programItems'));
    const filteredItems = programItems.filter(item => item.date === selectedDate);

    const partitions = [...new Set(filteredItems.map(item => item.partition))];
    partitions.sort((a, b) => {
      const lastCharA = parseInt(a.match(/\d+$/)[0]); // Extract and parse the last numeric character from partition A
      const lastCharB = parseInt(b.match(/\d+$/)[0]); // Extract and parse the last numeric character from partition B
      return lastCharA - lastCharB; // Sort based on the numeric value of the last character
    });

    const sessions = partitions.reduce((acc, partition) => {
      acc[partition] = filteredItems.filter(item => item.partition === partition);
      return acc;
    }, {});
    console.log(sessions);

    return { partitions, sessions };
  } catch (error) {
    console.error('Error fetching partitions and sessions:', error);
    return { partitions: [], sessions: {} };
  }
};

export const fetchProgramItemsForSession = async (session) => {
  try {
    const allConferenceItems = JSON.parse(localStorage.getItem('conferenceItems'));

    // Filter the items based on the session
    const programItemsForSession = allConferenceItems.filter(item => item.session === session);
    programItemsForSession.sort((a, b) => {
      const timeA = parseInt(a.time_start.replace(':', '')); // Extract and parse the time without the colon
      const timeB = parseInt(b.time_start.replace(':', '')); // Extract and parse the time without the colon
      if (timeA === timeB) {
        return a.id - b.id; // If the times are equal, sort by the smaller ID
      }
      return timeA - timeB; // Sort by the numeric value of the time
    });

    return programItemsForSession;
  } catch (error) {
    console.error(`Failed to fetch program items for session ${session}:`, error);
    return [];
  }
};

export const fetchAgendaItemsForSession = async (session, userAgenda) => {
  try {
    const allConferenceItems = JSON.parse(localStorage.getItem('conferenceItems'));

    // Filter the items based on the session and the user's agenda
    const agendaItemsForSession = allConferenceItems.filter(item => item.session === session && userAgenda.includes(item.id));
    agendaItemsForSession.sort((a, b) => {
      const timeA = parseInt(a.time_start.replace(':', '')); // Extract and parse the time without the colon
      const timeB = parseInt(b.time_start.replace(':', '')); // Extract and parse the time without the colon
      if (timeA === timeB) {
        return a.id - b.id; // If the times are equal, sort by the smaller ID
      }
      return timeA - timeB; // Sort by the numeric value of the time
    });

    return agendaItemsForSession;
  } catch (error) {
    console.error(`Failed to fetch agenda items for session ${session}:`, error);
    return [];
  }
};
